import { HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { JsonHttpService } from '../../shared/http/json-http.service'

@Injectable({
    providedIn: 'root'
})
export class TrackingDocumentShowerService {

    constructor(private httpService: JsonHttpService) { }

    getDocumentShowToken(documentId: number, fileType: string, fileGuid: string): Promise<string> {
        const options = {
            params: new HttpParams()
                .set('documentId', `${documentId}`)
                .set('fileType', fileType)
                .set('fileGuid', fileGuid)
        };
        return this.httpService.get('/api/tracking/show-document/get-document-show-token', options).toPromise();
    }

    getInterchangeInShowToken(interchangeInId: number, fileType: string, fileGuid: string): Promise<string> {
        const options = {
            params: new HttpParams()
                .set('interchangeInId', `${interchangeInId}`)
                .set('fileType', fileType)
                .set('fileGuid', fileGuid)
        };
        return this.httpService.get('/api/tracking/show-document/get-interchange-in-show-token', options).toPromise();
    }
}
